import React, { useState } from "react";
import axios from 'axios';
import Swal from "sweetalert2"; 
import "../Email.css";

const Email = () => {
    const [formData, setFormData] = useState({
        Desde: "",
        Nombre: "",
        Email: "",
        Cuerpo: "",
        file: null
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            file: e.target.files[0] // Guarda el archivo seleccionado
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const config = "https://memeworld.exchange/mail.php";

        // Crear FormData para enviar archivos
        const formDataToSend = new FormData();
        formDataToSend.append("Desde", formData.Desde);
        formDataToSend.append("Nombre", formData.Nombre);
        formDataToSend.append("Email", formData.Email);
        formDataToSend.append("Cuerpo", formData.Cuerpo);
        if (formData.file) {
            formDataToSend.append("file", formData.file);
        }

        try {
            const response = await axios.post(config, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Éxito",
                    text: "El email ha sido enviado correctamente.",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Hubo un problema al enviar el email.",
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se pudo enviar el email.",
            });
        }
    };

    return (
        <form className="form" onSubmit={handleSubmit}>
            <div className="input-field">
                <label htmlFor="Desde">Desde:</label>
                <input 
                    type="email" 
                    name="Desde" 
                    value={formData.Desde} 
                    onChange={handleChange} 
                    required 
                />
            </div>

            <div className="input-field">
                <label htmlFor="Nombre">Nombre:</label>
                <input 
                    type="text" 
                    name="Nombre" 
                    value={formData.Nombre} 
                    onChange={handleChange} 
                    required 
                />
            </div>

            <div className="input-field">
                <label htmlFor="Email">Email:</label>
                <input 
                    type="email" 
                    name="Email" 
                    value={formData.Email} 
                    onChange={handleChange} 
                    required 
                />
            </div>

            <div className="input-field">
                <label htmlFor="Comentario">Cuerpo:</label>
                <textarea 
                    name="Cuerpo" 
                    value={formData.Cuerpo} 
                    onChange={handleChange} 
                    required 
                />
            </div>

            <div className="input-field">
                <label htmlFor="file">Adjuntar archivo:</label>
                <input 
                    type="file" 
                    name="file" 
                    onChange={handleFileChange} 
                />
            </div>

            <button className="btn-submit" type="submit">Enviar</button>
        </form>
    );
};

export default Email;
